/**
 * @store 门户 企业 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    // 友情链接
    async queryLinks() {
      return await api.post(`/api/index/getLinks`, {
        linkPosition: 'link_class_2_',
      });
    },
    async queryAbout() {
      return await api.post(`/api/article/newsList`, {
        type: 'about',
      });
    },
  },
}
